<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap>
      <v-flex xs12>
        <h1 v-if="carrier.id">
          {{ $t('editModel', { model: $tc('models.carrier', 1) }) }}
        </h1>
        <h1 v-else>
          {{ $t('createModel', { model: $tc('models.carrier', 1) }) }}
        </h1>
      </v-flex>

      <v-flex xs12>
        <v-form @submit.prevent="submit">
          <v-card class="mt-4">
            <v-card-text>
              <v-container fluid grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm12 md4>
                    <v-text-field v-model="carrier.name"
                                  name="name"
                                  :label="$t('attrs.name')"
                                  v-validate="'required'"
                                  :error-messages="errors.collect('name')"
                                  data-vv-name="name"
                                  :data-vv-as="$t('attrs.name')"
                                  required
                                  ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md4>
                    <v-select v-model="carrier.provider_id"
                              :items="providers"
                              item-value="id"
                              item-text="name"
                              :label="$tc('models.provider')"
                              v-validate="'required'"
                              :error-messages="errors.collect('provider_id')"
                              data-vv-name="provider_id"
                              :data-vv-as="$tc('models.provider')"
                              required
                              ></v-select>
                  </v-flex>

                  <v-flex xs12 sm12 md4>
                    <v-select v-model="carrier.status"
                              :items="statuses"
                              item-value="id"
                              item-text="name"
                              :label="$t('attrs.status')"
                              v-validate="'required'"
                              :error-messages="errors.collect('status')"
                              data-vv-name="status"
                              :data-vv-as="$t('attrs.status')"
                              required
                              ></v-select>
                  </v-flex>

                  <v-flex xs12 sm12 md4>
                    <v-text-field :label="$t('selectImage')" @click="pickFile" v-model="imageName" prepend-icon="attach_file"></v-text-field>
                    <input type="file" style="display: none" ref="image" accept="image/*" @change="onFilePicked">
                    <img :src="imageUrl" width="150" v-if="imageUrl"/>
                  </v-flex>

                  <v-flex xs12 sm12 md4>
                    <v-text-field v-model="carrier.first_limit_size"
                                  name="firstDimensionLimit"
                                  :label="$t('attrs.first_dimension_limit')"
                                  type="number"
                                  ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md4>
                    <v-text-field v-model="carrier.first_limit_cost"
                                  name="firstLimitCost"
                                  :label="$t('attrs.first_limit_cost')"
                                  type="number"
                                  ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md4>
                    <v-text-field v-model="carrier.last_limit_size"
                                  name="lastDimensionLimit"
                                  :label="$t('attrs.last_dimension_limit')"
                                  type="number"
                                  ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md4>
                    <v-text-field v-model="carrier.last_limit_cost"
                                  name="lastLimitCost"
                                  :label="$t('attrs.last_limit_cost')"
                                  type="number"
                                  ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md4>
                    <v-text-field v-model="carrier.girth"
                      name="girth"
                      :label="$t('attrs.girth')"
                      type="number"
                    ></v-text-field>
                  </v-flex>

                  <template v-if="showInsurance">
                    <v-flex xs12 sm12 md4>
                      <v-select v-model="carrier.insurance_type"
                        :items="insuranceTypes"
                        item-value="id"
                        item-text="name"
                        :label="$tc('attrs.insurance_type')"
                        v-validate="'required'"
                        :error-messages="errors.collect('insurance_type')"
                        data-vv-name="insurance_type"
                        :data-vv-as="$tc('attrs.insurance_type')"
                        required
                      ></v-select>
                    </v-flex>

                    <v-flex xs12 sm12 md4>
                      <v-text-field v-model="carrier.insurance_percentage"
                        name="insurance_percentage"
                        :label="$t('attrs.insurance_percentage')"
                        type="number"
                      ></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm12 md4>
                      <v-text-field v-model="carrier.insurance_amount"
                        name="insurance_amount"
                        :label="$t('attrs.insurance_amount')"
                        type="number"
                      ></v-text-field>
                    </v-flex>
                  </template>

                  <v-flex xs12 sm12 md4 v-if="$auth.isDev()">
                    <v-checkbox v-model="carrier.pickup" label="Pickup"></v-checkbox>
                  </v-flex>

                  <template v-if="(($auth.isDev() || $auth.isMainAdmin()) && hasStaticPackage)">
                    <v-flex xs12 sm12 md4>
                      <v-text-field v-model="carrier.static_package_dimensions"
                                    name="static_package_dimensions"
                                    :label="$t('attrs.static_package_dimensions')"
                                    :persistent-hint="true"
                                    :hint="$t('attrs.static_package_dimensions_hint')"
                                    ></v-text-field>

                    </v-flex>
                  </template>

                  <template v-if="(($auth.isDev() || $auth.isAdmin()) && (carrier.provider_id == redpackProviderId))">
                    <v-flex xs12 sm12 md4>
                      <v-text-field v-model="carrier.redpack_static_package"
                                    name="redpackStaticPackage"
                                    :label="$t('attrs.static_package_dimensions')"
                                    :persistent-hint="true"
                                    :hint="$t('attrs.static_package_dimensions_hint')"
                                    ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 md4>
                      <v-checkbox v-model="carrier.use_redpack_static_package"
                                  :label="$t('attrs.use_redpack_static_package')"
                                  ></v-checkbox>
                    </v-flex>
                  </template>

                  <v-flex xs12 sm12 md4 v-if="$auth.isDev() || $auth.isMainAdmin()">
                    <v-checkbox v-model="carrier.freeze_settings"
                                :label="$t('attrs.freeze_settings')"
                                ></v-checkbox>
                  </v-flex>

                  <v-flex xs12 sm12 md12 v-if="$auth.isDev()">
                    <v-checkbox v-for="validator in validators" :key="validator.id"
                                class="ma-0"
                                v-model="validatorIds"
                                :label="validator.name"
                                :hint="validator.description"
                                :hide-details="!validator.description"
                                persistent-hint
                                :value="validator.id"
                                color="primary"
                                ></v-checkbox>
                  </v-flex>

                </v-layout>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" flat @click="back" :loading="loading" :disabled="loading">{{ $t('cancel') }}</v-btn>
              <v-btn color="primary" dark :loading="loading" :disabled="loading" type="submit">{{ $t('save') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Provider from '@/client/provider'
import Carrier from '@/client/carrier'
import Validator from '@/client/validator'
import Setting from '@/client/setting'

export default {
  name: 'CarrierFormView',

  props: {},

  data () {
    return {
      loading: false,
      showInsurance: false,
      providers: [],
      carrier: {},
      statuses: [
        { id: 'active', name: this.$t('list.statuses.active') },
        { id: 'suspended', name: this.$t('list.statuses.suspended') }
      ],
      validators: [],
      validatorIds: [],
      imageName: '',
      imageUrl: '',
      logo: '',
      redpackProviderId: ''
    }
  },

  components: {
  },

  computed: {
    staticPackageProviders () {
      const codes = ['EstafetaBot676', 'EstafetaBot007']
      return this.providers.filter(o => codes.includes(o.code)).map(o => o.id)
    },

    hasStaticPackage () {
      if (!this.carrier) { return false }
      if (!this.carrier.provider_id) { return false }

      return this.staticPackageProviders.includes(this.carrier.provider_id)
    },

    selectedProvider () {
      const def = { settings: {} }
      if (!this.carrier) { return def }
      if (!this.carrier.provider_id) { return def }

      return this.providers.find(o => o.id === this.carrier.provider_id) || def
    },

    insuranceTypes () {
      if (this.selectedProvider.settings.insurance) {
        return [
          { id: "none", name: this.$t('none') },
          { id: "internal", name: this.$t('internal') },
          { id: "provider", name: this.$tc('models.provider') },
        ]
      } else {
        return [
          { id: "none", name: this.$t('none') },
          { id: "internal", name: this.$t('internal') },
        ]
      }
    },
  },

  methods: {
    async submit () {
      const isValid = await this.$validator.validateAll()
      if (!isValid) { return }

      this.loading = true
      try {
        const formData = new FormData()
        formData.append('carrier[provider_id]', this.carrier.provider_id)
        formData.append('carrier[name]', this.carrier.name)
        formData.append('carrier[status]', this.carrier.status)
        formData.append('carrier[pickup]', this.carrier.pickup)
        formData.append('carrier[first_limit_cost]', this.carrier.first_limit_cost)
        formData.append('carrier[first_limit_size]', this.carrier.first_limit_size)
        formData.append('carrier[last_limit_cost]', this.carrier.last_limit_cost)
        formData.append('carrier[last_limit_size]', this.carrier.last_limit_size)
        formData.append('carrier[redpack_static_package]', this.carrier.redpack_static_package)
        formData.append('carrier[use_redpack_static_package]', this.carrier.use_redpack_static_package)
        formData.append('carrier[static_package_dimensions]', this.carrier.static_package_dimensions)
        formData.append('carrier[freeze_settings]', this.carrier.freeze_settings)
        formData.append('carrier[insurance_type]', this.carrier.insurance_type)
        formData.append('carrier[insurance_percentage]', this.carrier.insurance_percentage)
        formData.append('carrier[insurance_amount]', this.carrier.insurance_amount)
        formData.append('carrier[girth]', this.carrier.girth)
        this.validatorIds.forEach(id => {
          formData.append('carrier[validator_ids][]', id)
        })

        if (this.carrier.provider_id !== this.redpackProviderId) {
          formData.append('carrier[use_redpack_static_package]', false)
        }

        if (this.logo) {
          formData.append('carrier[logo]', this.logo)
        }

        await Carrier.saveFormData(this.carrier.id, formData)
        this.setNotification({
          color: 'success',
          message: this.$t('successfullySavedNotification')
        })
        this.back()
      } catch (err) {
        this.handleErr(err)
      }
      this.loading = false
    },

    pickFile () {
      this.$refs.image.click()
    },

    onFilePicked (e) {
      const files = e.target.files
      if(files[0] !== undefined) {
        this.logo = files[0]
        this.imageName = files[0].name
        if(this.imageName.lastIndexOf('.') <= 0) {
          return
        }
        const fr = new FileReader ()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          this.imageUrl = fr.result
        })
      } else {
        this.imageName = ''
        this.imageUrl = ''
      }
    }
  },

  watch: {
  },

  async mounted () {
    this.providers = await Provider.all({ per_page: 2000 })
    this.showInsurance = (await Setting.byKey("insurance")).value === "1"

    try {
      const redpack = this.providers.find(p => p.code == "Redpack")
      if (redpack) {
        this.redpackProviderId = redpack.id
      }
    } catch (err) {
      console.log("error", err)
      this.redpackProviderId = ""
    }

    this.validators = await Validator.all()
    this.carrier = new Carrier({
      status: "active",
      girth: 330,
      insurance_type: "none"
    })

    const id = this.$route.params.id
    if (id) {
      this.carrier = await Carrier.findOne(id, { include: "validators" })
      this.validatorIds = this.carrier.validators.map(o => o.id)
      if (this.carrier.logo && this.carrier.logo.url) {
        this.imageUrl = this.carrier.logo.url
      }
    }
  }
}
</script>
